<template>
	<div class="vx-col w-full">
		<div class="button-alignment-end">
			<div v-if="this.order.order.is_bol_vvb_order">
				<div v-if="isUsedForShipping">
					<div class="flex justify-end">
						<vx-tooltip :id="'shipVvbOrder' + order.order.id" text="Verwerk VVB bestelling in bol">
							<vs-button id="shipOrders" class="vs-con-loading__container mr-2" color="success" @click.native="shipVvbOrder()">
								<font-awesome-icon :icon="['fas', 'truck']" class="fa-icon"/>
							</vs-button>
						</vx-tooltip>

						<div v-for="deliveryOption in this.order.delivery_options">
							<vx-tooltip :id="'downloadVvbLabel' + order.order.id" class="vs-con-loading__container" :text="'Download VVB label - ' + deliveryOption.label_display_name + ' opnieuw'"
										v-if="deliveryOption.used_for_shipping">
								<vs-button color="primary" @click.native="downloadVvbLabel(deliveryOption.id)">
									<font-awesome-icon class="fa-icon" :icon="['fas', 'file-pdf']" style="font-size: 1.0rem"/>
								</vs-button>
							</vx-tooltip>
						</div>
					</div>
				</div>

				<div v-else>
					<div v-for="deliveryOption in this.order.delivery_options">
						<vx-tooltip :id="'downloadVvbLabel' + order.order.id" class="vs-con-loading__container" :text="'Download VVB label - ' + deliveryOption.label_display_name"
									v-if="deliveryOption.recommended">
							<vs-button color="primary" @click.native="downloadVvbLabel(deliveryOption.id)">
								<font-awesome-icon class="fa-icon" :icon="['fas', 'file-pdf']" style="font-size: 1.0rem"/>
								<span class="text-sm">
									{{ deliveryOption.label_display_name }} (VVB)
								</span>
							</vs-button>
						</vx-tooltip>
					</div>
				</div>
			</div>

			<printShippingLabel :order="this.order" :dymo-printer="this.dymoPrinter"/>

			<printSendCloudLabel :order="this.order"/>

			<dropdown :order="this.order" :dymo-printer="this.dymoPrinter"/>

		</div>
	</div>
</template>

<script>
import printShippingLabel from './printshippinglabel';
import dymoPrinter from '@/services/dymo/dymoPrinter';
import Dropdown from './dropdown';
import printSendCloudLabel from './printsendcloudlabel';
import downloadClient from "@/services/downloadClient";
import apiClient from "@/services/apiClient";

export default {
	components: {
		printSendCloudLabel,
		Dropdown,
		printShippingLabel,
	},
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	data() {
		return {
			popupVisible: false,
			totalTransactionFee: 0,
			totalMarge: 0,
			addressPrinter: null,
		}
	},
	computed: {
		isUsedForShipping() {
			if (!this.order || !Array.isArray(this.order.delivery_options)) {
				return false;
			}

			return this.order.delivery_options.some(option => {
				return option.used_for_shipping === true || option.used_for_shipping === 1 || option.used_for_shipping === '1';
			});
		}
	},
	methods: {
		shipVvbOrder() {
			this.startLoadingShipVvbOrder();

			console.log("===========================");
			console.log("shipVvbOrder function start");

			console.log("execute hideOrder");
			this.$store.dispatch('openOrdersStore/hideOrder', this.order);
			console.log("executed hideOrder");

			const params = {
				order_id: this.order.order.id,
			}

			console.log("execute post to orders/ship/vvb/ship");
			apiClient.post('orders/ship/vvb/ship', params, {timeout: 300000}).then(response => {
				console.log("executed succes post to orders/ship/vvb/ship");

				if (response.data.order.status === 3) {
					console.log("execute removeOrder");
					this.$store.dispatch('openOrdersStore/removeOrder', this.order);
					console.log("executed removeOrder");
				} else {
					console.log("execute showOrder");
					this.$store.dispatch('openOrdersStore/showOrder', this.order);
					console.log("executed showOrder");
					console.log("execute updateOrder");
					this.$store.dispatch('openOrdersStore/updateOrder', response.data);
					console.log("executed updateOrder");
				}

				this.stopLoadingShipVvbOrder();
			}).catch(error => {
				console.log("executed failed post to orders/ship/vvb/ship");
				console.log(error);
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het verwerken van de order is mislukt',
					color: 'danger'
				});

				console.log("show again order");
				console.log(this.order);

				console.log("execute showOrder");
				this.$store.dispatch('openOrdersStore/showOrder', this.order);
				console.log("executed showOrder");

				this.stopLoadingShipVvbOrder();
				console.log("===========================");
			});
		},
		startLoadingShipVvbOrder() {
			this.$vs.loading({
				container: '#shipVvbOrder' + this.order.order.id,
				scale: 0.45
			})
		},
		stopLoadingShipVvbOrder() {
			this.$vs.loading.close('#shipVvbOrder' + this.order.order.id + ' > .con-vs-loading');
		},
		downloadVvbLabel(deliveryOptionId) {
			this.startLoadingVvbLabel();

			const params = {
				order_id: this.order.order.id,
				order_bol_delivery_options_id: deliveryOptionId,
			}

			apiClient.put('orders/ship/vvb/select', params).then(response => {
				this.$store.dispatch('openOrdersStore/updateOrder', response.data);

				downloadClient.downloadVvbLabelPdf(this.order.order.id, deliveryOptionId).then(() => {
					this.stopLoadingVvbLabel();
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het downloaden van het label is mislukt',
					color: 'danger'
				});

				this.stopLoadingVvbLabel();
			})
		},
		startLoadingVvbLabel() {
			this.$vs.loading({
				container: '#downloadVvbLabel' + this.order.order.id,
				scale: 0.45
			})
		},
		stopLoadingVvbLabel() {
			this.$vs.loading.close('#downloadVvbLabel' + this.order.order.id + ' > .con-vs-loading');

			const params = {
				order_id: this.order.order.id,
			}

			apiClient.get('orders/get/order', {params}).then(response => {
				this.$store.dispatch('openOrdersStore/updateOrder', response.data);
			})
		}
	}
}
</script>
